export var ButtonColors = {
    primary: {
        main: "#1976d2",
        contrastText: "#fff",
        hover: "#1565c0",
        border: "#1976d2",
    },
    secondary: {
        main: "#9c27b0",
        contrastText: "#fff",
        hover: "#7b1fa2",
        border: "#9c27b0",
    },
    success: {
        main: "#2e7d32",
        contrastText: "#fff",
        hover: "#1b5e20",
        border: "#2e7d32",
    },
    error: {
        main: "#d32f2f",
        contrastText: "#fff",
        hover: "#9a0007",
        border: "#d32f2f",
    },
    warning: {
        main: "#ed6c02",
        contrastText: "#fff",
        hover: "#e65100",
        border: "#ed6c02",
    },
    info: {
        main: "#0288d1",
        contrastText: "#fff",
        hover: "#0277bd",
        border: "#0288d1",
    },
    neutral: {
        main: "#555",
        contrastText: "#333",
        hover: "#d5d5d5",
        border: "#ddd",
    },
};
